// extracted by mini-css-extract-plugin
export default {"blockwrapper":"aX","header":"bX","name":"cX","columns":"eX","imagewrapper":"fX","addinfo":"gX","description":"hX","price":"iX","old":"jX","new":"kX","desc_d":"lX","infoblock":"mX","desc_m":"nX"};
    if(module.hot) {
      // 1737143663831
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  